<template>
  <div class="home">
    <div :id="isShow ? 'open' : ''"></div>
    <div class="userInfo">
      <div class="header">
        <h3>个人信息</h3>
        <div class="line"></div>
      </div>
      <div v-if="!editShow" class="showContent">
        <div class="show">
          <p>姓名：</p>
          <h3>{{ userInfo.name }}</h3>
        </div>
        <div class="show">
          <p>手机号：</p>
          <div class="phone">
            <h3>{{ userInfo.phone }}</h3>
            <h4 @click="editPhone">修改手机号</h4>
          </div>
        </div>
        <div class="show">
          <p>单位名称：</p>
          <h3>{{ userInfo.unit }}</h3>
        </div>
        <div class="show">
          <p>邮箱：</p>
          <h3>{{ userInfo.email }}</h3>
        </div>
        <div class="show">
          <p>省市：</p>
          <h3>{{ userInfo.sheng }}{{ userInfo.shi }}</h3>
        </div>
        <div class="show">
          <p>详细地址：</p>
          <h3>{{ userInfo.site }}</h3>
        </div>
        <div class="show">
          <p>身份证正面：</p>
          <img :src="userInfo.zheng" alt />
        </div>
        <div style="margin-top:0.2rem" class="show">
          <p>身份证反面：</p>
          <img :src="userInfo.fan" alt />
        </div>
      </div>
      <div v-else class="showContent">
        <div class="show">
          <p>姓名：</p>
          <el-input
            size="medium"
            v-model="userInfo.name"
            placeholder="请输入内容"
          ></el-input>
        </div>
        <div class="show">
          <p>手机号：</p>
          <div class="phone">
            <h3>{{ userInfo.phone }}</h3>
            <h4>修改手机号</h4>
          </div>
        </div>
        <div class="show">
          <p>单位名称：</p>
          <el-input
            size="medium"
            v-model="userInfo.unit"
            placeholder="请输入内容"
          ></el-input>
        </div>
        <div class="show">
          <p>邮箱：</p>
          <el-input
            size="medium"
            v-model="userInfo.email"
            placeholder="请输入内容"
          ></el-input>
        </div>
        <div class="show">
          <p>省市：</p>
          <el-select
            style="margin-left:-0.2rem"
            size="medium"
            @change="selectSheng"
            v-model="userInfo.sheng"
            clearable
            placeholder="请选择省份"
          >
            <el-option
              v-for="item in shengData"
              :key="item.sheng"
              :label="item.sheng"
              :value="item.sheng"
            ></el-option>
          </el-select>
          <el-select
            style="margin-left:0.4rem"
            :disabled="shiData.length == 0 ? true : false"
            v-model="userInfo.shi"
            clearable
            placeholder="请选择市区"
            size="medium"
          >
            <el-option
              v-for="item in shiData"
              :key="item.name"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </div>
        <div class="show">
          <p>详细地址：</p>
          <el-input
            size="medium"
            v-model="userInfo.site"
            placeholder="请输入内容"
          ></el-input>
        </div>
        <div class="show">
          <p>身份证正面：</p>
          <img :src="userInfo.zheng" alt />
          <h2>身份证信息修改需要联系管理员</h2>
          <!-- <el-upload
            class="avatar-uploader"
            action="http://123.56.170.62:9999/tianwei/userzheng"
            ref="pictUpload"
            :show-file-list="false"
            list-type="picture-card"
            :on-change="picthandleChange"
            :before-upload="pictbeforeAvatarUpload"
            :auto-upload="false"
            :data="{phone:userInfo.phone}"
          >
            <img v-if="userInfo.zheng" :src="userInfo.zheng" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>-->
        </div>
        <div style="margin-top:0.2rem" class="show">
          <p>身份证反面：</p>
          <img :src="userInfo.fan" alt />
          <h2>身份证信息修改需要联系管理员</h2>
          <!-- <el-upload
            class="avatar-uploader"
            action="http://123.56.170.62:9999/tianwei/userfan"
            ref="fpictUpload"
            :show-file-list="false"
            list-type="picture-card"
            :on-change="fpicthandleChange"
            :before-upload="fpictbeforeAvatarUpload"
            :auto-upload="false"
            :data="{phone:userInfo.phone}"
          >
            <img v-if="userInfo.fan" :src="userInfo.fan" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>-->
        </div>
      </div>
      <div class="btn">
        <h3 v-if="!editShow" @click="editShow = true">修改</h3>
        <div v-else class="editBtn">
          <h3 @click="save">保存</h3>
          <h2 @click="giveUp">放弃</h2>
        </div>
      </div>
    </div>
    <!-- 弹出框登录 -->
    <div class="dialog" v-if="isShow">
      <div class="dContent">
        <div class="phone" v-if="nextShow">
          <el-input
            v-model="changephone.phone"
            placeholder="变更手机号码"
            clearable
          ></el-input>
        </div>
        <div class="phone" v-else>
          <h3>原手机号码：{{ userInfo.phone }}</h3>
        </div>
        <div class="code">
          <el-input
            v-model="changephone.vsCode"
            placeholder="请输入验证码"
            type="text"
            clearable
          ></el-input>
          <div class="send">
            <el-button
              v-if="!disabled"
              type="primary"
              @click="getVerifyCode(changephone.phone)"
              >发送验证码</el-button
            >
            <span v-else>{{ btnTitle }}</span>
          </div>
        </div>
        <div class="dBtn">
          <el-button type="primary" @click="newPhone" v-if="nextShow"
            >确定</el-button
          >
          <el-button @click="getFirstCode" v-else type="primary"
            >下一步</el-button
          >
          <el-button type="info" @click="cancel">放弃</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Bus from "@/utils/bus.js"
import {
  Login,
  editRegister,
  getSheng,
  getReCode,
  nextCode,
} from "@/api/user.js"
export default {
  name: "Home",
  data() {
    return {
      editShow: false,
      isShow: false,
      nextShow: false,
      changephone: {
        phone: "",
        vsCode: "",
      },
      btnTitle: "",
      disabled: false,
      pictfileList: [],
      fpictfileList: [],
      userInfo: {
        name: "",
        phone: "",
        unit: "",
        email: "",
        site: "",
        sheng: "",
        shi: "",
        zheng: "",
        fan: "",
      },
      shiData: [],
      shengData: [],
    }
  },
  mounted() {
    this.getUser()
    this.getSs()
  },
  methods: {
    // 获取省市
    async getSs() {
      let sData = await getSheng()
      this.shengData = sData
    },
    // 修改个人信息
    async save() {
      if (
        this.userInfo.name &&
        this.userInfo.unit &&
        this.userInfo.email &&
        this.userInfo.sheng &&
        this.userInfo.shi &&
        this.userInfo.site
      ) {
        if (this.pictfileList.length > 0) {
          this.$refs.pictUpload.submit()
        }
        if (this.fpictfileList.length > 0) {
          this.$refs.fpictUpload.submit()
        }
        let userInfo = new FormData()
        userInfo.append("phone", this.userInfo.phone)
        userInfo.append("name", this.userInfo.name)
        userInfo.append("unit", this.userInfo.unit)
        userInfo.append("email", this.userInfo.email)
        userInfo.append("sheng", this.userInfo.sheng)
        userInfo.append("shi", this.userInfo.shi)
        userInfo.append("site", this.userInfo.site)
        let reg = await editRegister(userInfo)
        if (reg.code == "OK") {
          this.$message.success("编辑完成")
          this.$store.commit("user/getUserInfo", reg.phoneuser)
          this.getUser()
          // this.userInfo = {
          //   name: "",
          //   phone: "",
          //   unit: "",
          //   email: "",
          //   site: "",
          //   sheng: "",
          //   shi: ""
          // };
          this.editShow = false
        } else {
          this.$message.error(reg.msg)
        }
      } else {
        this.$message.warning("有选项未填写")
      }
    },
    selectSheng(sheng) {
      this.shengData.forEach((item) => {
        if (item.sheng == sheng) {
          this.shiData = item.shi
          this.userInfo.shi = ""
        }
      })
    },
    getUser() {
      this.userInfo.name = this.$store.getters["user/getUsers"].name
      this.userInfo.phone = this.$store.getters["user/getUsers"].phone
      this.userInfo.unit = this.$store.getters["user/getUsers"].unit
      this.userInfo.email = this.$store.getters["user/getUsers"].email
      this.userInfo.site = this.$store.getters["user/getUsers"].site
      this.userInfo.sheng = this.$store.getters["user/getUsers"].sheng
      this.userInfo.shi = this.$store.getters["user/getUsers"].shi
      this.userInfo.zheng = this.$store.getters["user/getUsers"].zheng
      this.userInfo.fan = this.$store.getters["user/getUsers"].fan
    },
    // 放弃修改个人信息
    giveUp() {
      this.editShow = false
      this.getUser()
    },
    pictbeforeAvatarUpload(file) {
      return new Promise((resolve, reject) => {
        resolve()
      })
    },
    fpictbeforeAvatarUpload(file) {
      return new Promise((resolve, reject) => {
        resolve()
      })
    },
    picthandleChange(file, fileList) {
      const isJPG =
        file.raw.type == "image/png" ||
        file.raw.type == "image/jpg" ||
        file.raw.type == "image/jpeg"
      const isLt2M = file.raw.size / 1024 / 1024 < 10
      if (!isJPG) {
        this.$message.error("身份证图片只能是 png/jpg/jpeg 格式!")
      }
      if (!isLt2M) {
        this.$message.error("身份证图片不能超过 10MB!")
      }
      if (!isJPG || !isLt2M) {
      } else {
        this.pictfileList = fileList
        this.userInfo.zheng = URL.createObjectURL(file.raw)
      }
    },
    fpicthandleChange(file, fileList) {
      const isJPG =
        file.raw.type == "image/png" ||
        file.raw.type == "image/jpg" ||
        file.raw.type == "image/jpeg"
      const isLt2M = file.raw.size / 1024 / 1024 < 10
      if (!isJPG) {
        this.$message.error("身份证图片只能是 png/jpg/jpeg 格式!")
      }
      if (!isLt2M) {
        this.$message.error("身份证图片不能超过 10MB!")
      }
      if (!isJPG || !isLt2M) {
      } else {
        this.pictfileList = fileList
        this.userInfo.fan = URL.createObjectURL(file.raw)
      }
    },
    // 修改手机号
    editPhone() {
      this.isShow = true
      this.changephone.phone = Number(this.userInfo.phone)
    },
    // 放弃修改手机号
    cancel() {
      this.isShow = false
      this.nextShow = false
      this.changephone = {
        phone: "",
        vsCode: "",
      }
      clearInterval(this.timer)
      this.disabled = false
    },
    // 获取验证码点击下一步
    async getFirstCode() {
      if (this.isVerifyCode(this.changephone.vsCode)) {
        let verifyCode = new FormData()
        verifyCode.append("phone", this.changephone.phone)
        verifyCode.append("mobile_code", this.changephone.vsCode)
        let code = await nextCode(verifyCode)
        if (code.code == "OK") {
          this.changephone = {
            phone: "",
            vsCode: "",
          }
          this.nextShow = true
          clearInterval(this.timer)
          this.disabled = false
        } else {
          this.$message({
            type: "error",
            message: code.msg,
          })
        }
      } else {
        this.$message({
          type: "warning",
          message: "有信息未填写",
        })
      }
    },
    // 修改手机号确定
    async newPhone() {
      if (
        this.isCellPhone(this.changephone.phone) &&
        this.isVerifyCode(this.changephone.vsCode)
      ) {
        let verifyCode = new FormData()
        verifyCode.append("organization", this.changephone.phone)
        verifyCode.append("mobile_code", this.changephone.vsCode)
        verifyCode.append("id", this.$store.state.user.userInfo.id)
        let code = await nextCode(verifyCode)
        if (code.code == "OK") {
          this.$message({
            type: "success",
            message: "修改成功",
          })
          this.$store.commit("user/getUserInfo", code.user)
          this.getUser()
          this.cancel()
        } else {
          this.$message({
            type: "error",
            message: code.msg,
          })
          this.disabled = false
          clearInterval(this.timer)
        }
      } else {
        this.$message({
          type: "warning",
          message: "有信息未填写",
        })
      }
    },
    // 获取验证码
    async getVerifyCode(phone) {
      if (this.isCellPhone(phone)) {
        this.validateBtn()
        // 发送网络请求
        let verifyCode = new FormData()
        verifyCode.append("phone", phone)
        let code = await getReCode(verifyCode)
        if (code.code == "ERR") {
          this.$message({
            type: "error",
            message: code.msg,
          })
        }
      } else {
        this.$message({
          type: "warning",
          message: "手机号有误",
        })
      }
    },
    //验证手机号格式
    isCellPhone(val) {
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(val)) {
        return false
      } else {
        return true
      }
    },
    //验证验证码
    isVerifyCode(val) {
      if (!/\d{6}$/.test(val) || val.length !== 6) {
        return false
      } else {
        return true
      }
    },
    //倒计时
    validateBtn() {
      let time = 60
      this.disabled = true
      this.btnTitle = time + "秒后重试"
      this.timer = setInterval(() => {
        if (time == 0) {
          clearInterval(this.timer)
          this.disabled = false
        } else {
          // 倒计时
          time--
          this.btnTitle = time + "秒后重试"
          this.disabled = true
        }
      }, 1000)
    },
  },
  components: {},
}
</script>

<style lang="less" scoped>
@color: #512475;
#open {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  transition: all 0.3s ease-in-out;
  z-index: 95;
}

.info {
  margin-left: 30px;
  line-height: 2;

  h2 {
    font-size: 16px;
    color: #333333;
    font-weight: bold;
  }

  p {
    font-size: 14px;
    color: #666;
  }

  .line {
    width: 130px;
    height: 2px;
    margin-left: -20px;
    background-color: #555;
  }
}

.home {
  width: 100%;
  padding: 10px 0 40px;
  .userInfo {
    margin: 0 50px;
    .header {
      width: 100%;
      h3 {
        margin: 20px 0;
        font-size: 18px;
        font-weight: 600;
        color: #333333;
      }
      .line {
        width: 100%;
        background-color: #dbdbdb;
        height: 1px;
      }
    }
    .showContent {
      margin-top: 20px;
      .show {
        margin-right: 40px;
        line-height: 3;
        display: flex;
        font-size: 16px;
        color: #666;
        /deep/ .el-upload--picture-card {
          border: none;
          width: 200px;
          height: 120px;
        }
        .el-input {
          margin-top: 4px;
        }
        p {
          width: 110px;
        }
        .phone {
          flex: 1;
          display: flex;
          justify-content: space-between;
          h4 {
            width: 110px;
            height: 30px;
            line-height: 30px;
            color: #666;
            font-size: 16px;
            border-radius: 5px;
            text-align: center;
            background-color: #fff;
            border: 1px solid #666;
            cursor: pointer;
            margin-top: 10px;
          }
        }
        img {
          width: 200px;
          height: 120px;
        }
        h2 {
          font-size: 16px;
          color: red;
          margin-left: 20px;
        }
      }
    }
    .btn {
      h3 {
        width: 120px;
        height: 36px;
        line-height: 36px;
        color: #fff;
        font-size: 16px;
        border-radius: 5px;
        text-align: center;
        background-color: #0687c8;
        margin: 80px auto 0px;
        cursor: pointer;
      }
      .editBtn {
        display: flex;
        h2 {
          width: 120px;
          height: 36px;
          line-height: 36px;
          color: #fff;
          font-size: 16px;
          border-radius: 5px;
          text-align: center;
          background-color: #ccc;
          margin: 80px auto 0px;
          cursor: pointer;
        }
      }
    }
  }
  .dialog {
    width: 350px;
    height: 280px;
    background-color: #fff;
    position: fixed;
    border-radius: 5px;
    top: 25%;
    left: calc((100vw - 350px) / 2);
    z-index: 100;
    font-size: 14px;
    color: #666;
    .dContent {
      width: 280px;
      margin: 0 auto;
      .phone {
        width: 290px;
        margin: 45px auto 15px;
        h3 {
          height: 40px;
          line-height: 40px;
        }
      }
      .code {
        width: 100%;
        display: flex;
        .send {
          width: 100px;
          margin-left: 20px;
        }
      }
      .dBtn {
        margin: 50px 0;
        display: flex;
        justify-content: space-around;
        .el-button {
          width: 100px;
        }
      }
    }
  }
}
</style>
